import { useEffect } from "react";

const SITE = "Juli Klein's A/C Services";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : `${SITE} | A/C Repair & Maintenance — Fort Myers, Naples, Estero & Bonita Springs`;
    if (description) {
      const tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", description);
    }
  }, [title, description]);
}
